import { render, staticRenderFns } from "./LastChanges.vue?vue&type=template&id=6ef0d828&scoped=true&"
import script from "./LastChanges.vue?vue&type=script&lang=js&"
export * from "./LastChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef0d828",
  null
  
)

export default component.exports